import React, { CSSProperties, useContext } from 'react';
import './index.scss';
import { ThemeContext } from '../../store/ThemeProvider';

interface ILoadMore {
  loading: boolean;
  children?: React.ReactNode;
  style?: CSSProperties;
}
const LoadMore = (props: ILoadMore) => {
  const { h2Color, componentColor } = useContext(ThemeContext);
  const isChildrenString = typeof props.children === 'string';

  return (
    <div
      className="load-more"
      style={{ backgroundColor: componentColor, ...props.style }}
    >
      {props.loading && <span className="icon-loading" />}
      {isChildrenString
        ? !!props.children && (
            <span style={{ color: h2Color, padding: 10 }}>
              {props.children}
            </span>
          )
        : props.children}
    </div>
  );
};

export default LoadMore;
